module.exports = __webpack_public_path__ + "media/img/files/file-3-2509dde8e97cda8688c1e3ba43ac6735.jpg";